// use common.js, so we can consume the config modules in the build flow
module.exports = Object.freeze({
  appName: 'lp-le-reporting-bots',
  appCode: 'rb',
  sentry: {
    sentryOrgId: 'liveperson-platform', // Your Sentry organization ID
    sentryAppName: 'report-center',   // Your module's unique Sentry project name
  },
});
